"use client";

import React from "react";

import {
  getUnreadMessagesCount,
  UnreadMessagesCount,
} from "@peerspace/bellhop";

import type { SnakeToCamel } from "~/types/utility.types";
import { snakeToCamel } from "~/utils/snakeToCamel";

type NormalizedMessages = SnakeToCamel<UnreadMessagesCount>;

type MessagesDataContextType = {
  messages: NormalizedMessages | undefined;
};

type MessagesDataContextProviderProps = React.PropsWithChildren;

const MessagesDataContext = React.createContext<MessagesDataContextType | null>(
  null,
);

// TODO: this can turn into a Tanstack Query, bc called after we have the user, and we can remove this provider

const MessagesDataProvider = ({
  children,
}: MessagesDataContextProviderProps) => {
  const [messages, setMessages] = React.useState<
    NormalizedMessages | undefined
  >();

  React.useEffect(() => {
    const fetchMessages = async () => {
      try {
        const data = await getUnreadMessagesCount();
        setMessages(snakeToCamel(data));
      } catch {
        setMessages(undefined);
      }
    };

    fetchMessages();
  }, []);

  return (
    <MessagesDataContext.Provider value={{ messages }}>
      {children}
    </MessagesDataContext.Provider>
  );
};

export { MessagesDataContext, MessagesDataProvider };

export type { NormalizedMessages, MessagesDataContextType };
